import React from 'react';

import { notEmpty } from 'utils/ramdaAdditions';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

const ActionVacancyLibObjList = ({ objectList }) => notEmpty(objectList) ? (
    <div>
        <DefinitionHeader translate="education.actionVacancy.card.libraryObjects" />
        <ul className="action-vacancy-objlist panel-view">
            { objectList.map(obj => <li className="m-b-15" key={obj.objectId}>{obj.name}</li>) }
        </ul>
    </div>
) : null;

export default ActionVacancyLibObjList;
